<div class="flex w-full flex-col gap-5">
  @if (!smsIsSent()) {
    <div class="mt-5 font-semibold">
      {{ 'setup-two-factor-auth-sms.explain.header' | translate }}
    </div>
    <div>
      <span class="font-semibold">
        {{ 'setup-two-factor-auth-sms.phone.label' | translate }}
        <span class="text-negative-150">*</span>
      </span>
      <div class="py-3">
        <pay-phone-input [formControl]="this.formSendSms.controls.phoneNumber" />
        <div class="my-2 text-sm text-neutral-80 sm:px-2">
          {{ 'setup-two-factor-auth-app.sms.extra-text' | translate }}
        </div>
      </div>
    </div>
    <pay-button-primary [rounded]="'rounded-md'" (click)="sendSms()">{{ 'setup-two-factor-auth-sms.button-send-sms' | translate }}</pay-button-primary>
  } @else {
    <div class="mt-5">
      <span class="hover:cursor-text">
        {{ 'setup-two-factor-auth-sms.activation-code.send-to' | translate: { PhoneNumber: this.phoneNumber() } }}
        @if (this.retryInSeconds() < 1) {
          <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="sendSmsToUser()">
            {{ 'setup-two-factor-auth-sms.activation-code.send-again' | translate }}
          </span>
        } @else {
          <span class="text-neutral-60 underline">
            {{ 'setup-two-factor-auth-sms.activation-code.retry' | translate: { RetryInSeconds: this.retryInSeconds() } }}
          </span>
        }
      </span>
    </div>
    <div>
      <span class="font-semibold">
        {{ 'setup-two-factor-auth-sms.code.label' | translate }}
        <span class="text-negative-150">*</span>
      </span>
      <div class="py-3">
        <pay-lib-pin-entry #pinEntryComponent (valueEntered)="submitPinEntry()" [pinCount]="5" />
        <div class="my-2 text-sm text-neutral-80 sm:px-2">
          {{ 'setup-two-factor-auth-app.code.extra-text' | translate }}
        </div>
      </div>
    </div>
    <pay-button-primary [loading]="this.loading()" (click)="submitPinEntry()" [rounded]="'rounded-lg'">
      {{ 'setup-two-factor-auth-sms.button-setup' | translate }}
    </pay-button-primary>
  }
  @if (error(); as err) {
    <pay-login-error-badge [error]="err" />
  }
</div>
